<lm-card>
    <lm-card-header>Scegli lingua</lm-card-header>
    <lm-card-content>
        <div *ngFor="let lang of languageList">
            <lm-radio-button groupName="languageRadio"
              label="{{lang.label}}" valueName="{{lang.code}}"
              (change)="changeLanguage(lang.code)"
              selected="{{ selectedLang }}"></lm-radio-button>
          </div>
    </lm-card-content>
</lm-card>